import type { ChartLink } from "@/types";

export const SANKEY_NODE_GAP = 20;

/** Leave space for every node in the widest column, including converging flows. */
export function sankeyHeight(links: ChartLink[], requestedHeight = 0): number {
  const incoming = new Map<string, number>();
  const outgoing = new Map<string, string[]>();
  const depths = new Map<string, number>();
  for (const { source, target } of links) {
    if (!incoming.has(source)) incoming.set(source, 0);
    incoming.set(target, (incoming.get(target) ?? 0) + 1);
    outgoing.set(source, [...(outgoing.get(source) ?? []), target]);
  }
  const queue = [...incoming.keys()].filter((name) => incoming.get(name) === 0);
  for (let i = 0; i < queue.length; i++) {
    const name = queue[i];
    const depth = depths.get(name) ?? 0;
    depths.set(name, depth);
    for (const target of outgoing.get(name) ?? []) {
      depths.set(target, Math.max(depths.get(target) ?? 0, depth + 1));
      incoming.set(target, incoming.get(target)! - 1);
      if (incoming.get(target) === 0) queue.push(target);
    }
  }
  const lastDepth = Math.max(0, ...depths.values());
  const columns = new Map<number, number>();
  for (const name of incoming.keys()) {
    // ECharts' default justify alignment moves terminal nodes to the last column.
    const depth = outgoing.has(name) ? (depths.get(name) ?? 0) : lastDepth;
    columns.set(depth, (columns.get(depth) ?? 0) + 1);
  }
  const widest = Math.max(0, ...columns.values());
  return Math.max(480, requestedHeight, 72 + widest * (SANKEY_NODE_GAP + 8));
}
